// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"408":"0192c485","829":"8c58a82c"}[chunkId] + ".chunk.css";
};